import React from 'react';
import {combineReducers} from 'redux';
import {connect, Provider} from 'react-redux';
import CarDamageStore from './CarDamageStore';

import {
  Button,
  ButtonToolbar,
  DropdownButton,
  SplitButton,
  MenuItem,
  ControlLabel,
  InputGroup,
  FormGroup,
  Row,
  Col,
  Form,
  FormControl,
  Tabs,
  Tab,
} from 'react-bootstrap';
import Select from 'react-select';
import FontAwsome from 'react-fontawesome';
import CarLayout
  from '../../component/element/CarDamageForm/CarLayout/CarLayout';
import WageItem from '../../component/element/CarDamageForm/WageItem/WageItem';
import DamageList
  from '../../component/element/CarDamageForm/DamageList/DamageList';

import StockList
  from '../../component/element/CarDamageForm/StockList/StockList';

import CarDamageForm from './CarDamageForm';
import './CarDamageContainer.css';

const store = CarDamageStore();

export default class CarDamageContainer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div>
        <Provider store={store}>
          <div className="car-damage-container">
            <CarDamageForm wo={this.props.wo || ''} />
          </div>
        </Provider>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/view/workdoc/CarDamageContainer.js